import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_WEIGHT_PROXIMA_SEMIBOLD, LEGACY_FONT_PROXIMA_13} from 'styles/FontConstants';
import {Header1} from 'ui-library/Headers';

import BackupRecordsTables from './BackupRecordsTables';

export default function InstitutionBackupsPage(): JSX.Element {
  return (
    <div className={css(styles.page)}>
      <Header1 className={css(styles.headerText)}>Institution Backups</Header1>
      <div className={css(styles.bodyText)}>
        <p>
          Some academic institutions partner with Benchling to administer their scientists' data. These
          licensed institutions back up data in Benchling projects that their users own.
        </p>
        <p>Institutions receive backups of a project when:</p>
        <ul>
          <li>the owner of the project is a member of the licensed institution</li>
          <li>the project is owned by an organization whose admin is a member of the licensed institution</li>
        </ul>
        <p>
          Any data you contribute to the following Benchling projects will be backed up to the corresponding
          institutions. That data will be audited and attributable to you.
        </p>
        <p>
          Contact <a href="mailto:support@benchling.com">support@benchling.com</a> with questions.
        </p>
      </div>
      <BackupRecordsTables />
    </div>
  );
}

const styles = StyleSheet.create({
  headerText: {
    fontSize: 24,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    marginTop: 15,
    marginBottom: 30,
  },
  page: {
    ...LEGACY_FONT_PROXIMA_13,
  },
  bodyText: {
    marginBottom: 30,
  },
});
